// extracted by mini-css-extract-plugin
export default {"popup":"popup___af3c23c824551ee7a3c7","hidden":"hidden___a21c2a4a12b750431788","title":"title___b2642bf39f0f0774f67b","close":"close___eb751c6623c820c4fff9"};